import {Component, QueryList, ViewChildren} from '@angular/core';
import {AlertController, ModalController, NavController, NavParams, Select} from 'ionic-angular';
import {FormBuilder, FormGroup, Validators, ValidationErrors, AbstractControl, FormControl} from "@angular/forms";
import { Platform } from "ionic-angular";
import { DataService } from "../../services/data.service";
import { SuperTabsController } from "../../components/ionic2-super-tabs/src";
import { ReportService } from "../../services/report.service";
import { GeolocationService } from "../../services/geolocation.service";
import { ApiService } from "../../services/api.service";
import { SignaturePage } from "../signature/signature";
import { ReportApprovePhotoPage } from "../report-approve-photo/report-approve-photo";
import { ReportTermsPage } from "../report-terms/report-terms";

@Component({
  selector: 'page-report-submit',
  templateUrl: 'report-submit.html',
})
export class ReportSubmitPage {

  @ViewChildren(Select) ionSelects: QueryList<Select>;

  data: any;
  newPhotos: any;
  newPhotosUnapproved = 0;
  submitAttempt = false;
  reportForm: FormGroup;
  isDrawing = false;
  timeout = null;
  userSignature = '';
  userSignatureDisabled = false;
  skills:any = null;
  unitType = 1;
  workorderType = 1;
  isUnitOk = true;
  isUnitSafe = true;
  showIsOk = false;
  minutesWorked = 0;
  hoursWorked = '';
  partsUsed = [];
  nextCheckRequired = false;
  hasRookgasmetingSubscription = false;
  companyUsers = [];
  showFooter = false;
  country = 'NL';

  datePickerOptions: any = {
    buttons: [{
      text: 'Leeg maken',
      handler: () => {
        this.reportForm.controls['next_check'].setValue(null);
      }
    }]
  };

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public platform: Platform,
    public modalCtrl: ModalController,
    public alertCtrl: AlertController,
    public dataService: DataService,
    public superTabsCtrl: SuperTabsController,
    public reportService: ReportService,
    public geolocationService: GeolocationService,
    public apiService: ApiService
  ) {
    this.initForm();
  }

  initForm(){
    this.data = this.reportService.getData();
    let has_data = (this.data.submit != null);
    let has_customer_client = (this.data.customers && this.data.customers.client != null);
    // Check ROOKGASMETING subscription
    this.hasRookgasmetingSubscription = this.apiService.hasActiveSubscription('ROOKGASMETING');
    // Set next_check
    let next_date = new Date();
    if(this.data._selected_unit && this.data._selected_unit.service_interval){
      next_date.setMonth(next_date.getMonth() + parseInt(this.data._selected_unit.service_interval));
    } else {
      next_date.setMonth(next_date.getMonth() + 24);
    }
    let next_check = next_date.getFullYear().toString() + '-' + ((next_date.getMonth() + 1) <= 9 ? '0' : '') + (next_date.getMonth() + 1).toString() + '-' + ((next_date.getDate()) <= 9 ? '0' : '') + next_date.getDate().toString();
    if(has_data && this.data.submit.next_check){
      next_check = this.data.submit.next_check;
    }
    // Set name
    let name = (this.data.customers && this.data.customers.client && this.data.customers.client.firstname != null && this.data.customers.client.lastname != null ? this.data.customers.client.firstname + ' ' + this.data.customers.client.lastname : '');
    if(has_data && this.data.submit.name){
      name = this.data.submit.name;
    }
    // Set nextCheckRequired (true bij 1e inbedrijfstelling en Onderhoud)
    if(this.data.workorder_type == '1' || this.data.workorder_type == '2') {
      this.nextCheckRequired = true;
    } else {
      this.nextCheckRequired = false;
      // Maak next_check default leeg als deze niet verplicht is.
      next_check = (has_data && this.data.submit.next_check ? this.data.submit.next_check : '');
    }
    // Get companyUsers
    this.dataService.getCompanyUsers().then((company_users: any) => {
      this.companyUsers = company_users;
    }).catch(() => {});
    // Set country
    if (this.data.customers.client && this.data.customers.client.country) {
      this.country = this.data.customers.client.country;
    }
    // Define form
    this.reportForm = this.formBuilder.group({
      terms_agreed: new FormControl((has_customer_client ? this.data.customers.client.terms_agreed : false), Validators.requiredTrue),
      time_agreed: new FormControl((has_customer_client ? this.data.customers.client.time_agreed : '')),
      send_to_customer_client: [(has_data ? this.data.submit.send_to_customer_client : false)],
      send_to_customer_invoice: [(has_data ? this.data.submit.send_to_customer_invoice : false)],
      send_to_customer_external: [(has_data ? this.data.submit.send_to_customer_external : false)],
      send_to_company: [(has_data ? this.data.submit.send_to_company : true)],
      send_to_okcv: [(has_data ? this.data.submit.send_to_okcv : false)],
      send_to_certification_authority: [(has_data ? this.data.submit.send_to_certification_authority : true)],
      send_to_authorized_supervision: [(has_data ? this.data.submit.send_to_authorized_supervision : true)],
      send_to_veka: [(has_data ? this.data.submit.send_to_veka : true)],
      other_email: [(has_data ? this.data.submit.other_email : ''), this.emailOrEmptyValidator],
      name: [name, Validators.required],
      next_check: (this.nextCheckRequired ? [next_check, Validators.required] : [next_check]),
      signature_customer: [(has_data ? this.data.submit.signature_customer : ''), Validators.required],
      signature_user: [(has_data ? this.data.submit.signature_user : ''), Validators.required],
      extra_company_user_id: [(has_data ? this.data.submit.extra_company_user_id : '')],
      gps_latitude: [(has_data ? this.data.submit.gps_latitude : '')],
      gps_longitude: [(has_data ? this.data.submit.gps_longitude : '')],
      gps_accuracy: [(has_data ? this.data.submit.gps_accuracy : '')],
    });
    this.updateForm();
  }

  updateForm(){
    // Get unittype
    if(this.data._selected_units && this.data._selected_units[0]) {
      this.unitType = parseInt(this.data._selected_units[0].unit_model_unit_type);
    }
    // Get workorderType
    this.workorderType = parseInt(this.data.workorder_type);
    // Set isUnitOk and isUnitSafe
    this.isUnitOk = (this.data.is_unit_ok == 'Ja');
    this.isUnitSafe = (this.data.is_unit_safe == 'Ja');
    this.showIsOk = (this.data._show_all_tabs === true && this.hasRookgasmetingSubscription);
    // Set hoursWorked
    this.minutesWorked = parseInt(this.data.minutes_worked);
    this.hoursWorked = Math.floor(this.minutesWorked / 60) + ':';
    this.hoursWorked += (Math.floor(this.minutesWorked % 60) < 10 ? '0' : '') + Math.floor(this.minutesWorked % 60);
    // Set partsUsed
    this.partsUsed = [];
    if(this.data.repairs && this.data.repairs.length > 0){
      for(let item of this.data.repairs){
        let title = item.part_title;
        if(item.part_serial){
          title += ' ' + item.description;
        }
        title = title.trim();
        if(title){
          this.partsUsed.push(title);
        }
      }
    }
    if(this.data.parts && this.data.parts.length > 0){
      for(let item of this.data.parts){
        let title = item.part_title;
        if(item.part_serial){
          title += ' (' + item.part_serial + ')';
        }
        if(title){
          this.partsUsed.push(title);
        }
      }
    }
    // Set newPhotos
    this.newPhotos = [];
    this.newPhotosUnapproved = 0;
    if(this.data.location && this.data.location.units && this.data.location.units.length > 0){
      for(let unit of this.data.location.units){
        if(unit.photos && unit.photos.length > 0){
          let index = 0;
          for(let photo of unit.photos){
            if(!photo.file_id){
              this.newPhotos.push({
                unit: unit,
                photo: photo,
                src: photo.src,
                index: index
              });
              if(!photo._approved){
                this.newPhotosUnapproved++;
              }
            }
            index++;
          }
        }
      }
    }
  }

  emailOrEmptyValidator(control: AbstractControl): ValidationErrors {
    if(!control.value) return null;
    return Validators.email(control);
  }

  confirm(){
    this.data._status = 'done';
    this.data.time_processed = Math.round(new Date().getTime() / 1000);
    this.save();
    this.navCtrl.parent.parent.pop();
  }

  approvePhoto(record, index){
    this.modalCtrl.create(ReportApprovePhotoPage, {
      record: record,
      index: index,
      parent: this
    }).present();
  }

  save(){
    this.submitAttempt = true;
    if(this.reportForm.valid){
      let values = this.reportForm.value;
      // Set terms_agreed
      if(this.data.customers.client){
        this.data.customers.client.terms_agreed = values.terms_agreed;
        this.data.customers.client.time_agreed = values.time_agreed;
      }
      delete values.terms_agreed;
      delete values.time_agreed;
      // Set submit data
      this.data.submit = values;
      // Add unit to reports
      if(this.data.reports && this.data.reports.length > 0){
        for(let report of this.data.reports){
          report.unit = this.data._selected_unit;
        }
      }
    }
  }

  isValid(){
    if(!this.reportForm.valid) return false;
    return this.isDataValid();
  }

  isDataValid(){
    if(this.data._valid.reportWorkorderPage !== 1) return false;
    if(this.data._valid.reportCustomerClientPage !== 1) return false;
    if(this.data._valid.reportSelectUnitPage !== 1) return false;
    if(this.data._valid.reportMeasurementPage !== 1) return false;
    if(this.data._valid.reportRepairsPage !== 1) return false;
    if(this.data._valid.reportChecklistPage !== 1) return false;
    if(this.newPhotosUnapproved > 0) return false;
    return true;
  }

  openSignatureCustomerModal(){
    this.modalCtrl.create(SignaturePage, {
      form: this.reportForm,
      field: 'signature_customer'
    }).present();
  }

  openSignatureUserModal(){
    this.modalCtrl.create(SignaturePage, {
      form: this.reportForm,
      field: 'signature_user'
    }).present();
  }

  openTerms(checkbox){
    if((this.reportForm.get('terms_agreed').value && checkbox) || (!this.reportForm.get('terms_agreed').value && !checkbox)){
      this.modalCtrl.create(ReportTermsPage, {
        form: this.reportForm
      }).present();
    }
    this.reportForm.get('terms_agreed').setValue(false);
  }

  updateGeolocation(){
    this.geolocationService.getCurrentPosition().then((coords) => {
      if(coords.latitude && coords.longitude && coords.accuracy){
        this.reportForm.patchValue({
          gps_latitude: coords.latitude,
          gps_longitude: coords.longitude,
          gps_accuracy: coords.accuracy
        });
      }
    });
  }

  ionViewDidEnter() {
    console.log('ReportSubmitPage: ionViewDidEnter');
    this.updateForm();
    this.updateGeolocation();
    // Translate ion-select fix
    if (this.ionSelects) this.ionSelects.map((select) => select._inputUpdated());
    // iOS footer display fix
    this.showFooter = false;
    setTimeout(() => {
      this.showFooter = true;
    }, 100);
  }

  ionViewDidLeave(){
    console.log('ReportSubmitPage: ionViewDidLeave');
    this.save();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ReportSubmitPage');
    this.apiService.getProfile().then((data) => {
      // @ts-ignore
      let form_data:any = data.company_user;
      if(form_data.user_signature){
        this.userSignature = form_data.user_signature;
        this.reportForm.controls['signature_user'].setValue(form_data.user_signature);
        this.userSignatureDisabled = true;
      } else {
        this.userSignatureDisabled = false;
      }
      if(form_data.skills){
        this.skills = form_data.skills;
      }
    }).catch(() => {});
  }

}



// WEBPACK FOOTER //
// ./src/pages/report-submit/report-submit.ts